import { fromJS } from 'immutable';

import { fetchPrintersRoutine, savePrinterRoutine, removePrinterRoutine } from '../routines';
import { updateOrAdd, remove } from './helper';

const initialState = fromJS({
  printers: {},
  printer: {},
  loading: true,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case fetchPrintersRoutine.SUCCESS:
      return state.set('printers', fromJS(action.payload.response));
    case fetchPrintersRoutine.FAILURE:
      return state.setIn(['printers', 'loading'], false);
    case savePrinterRoutine.SUCCESS:
      return state.updateIn(['printers','data'], updateOrAdd(fromJS(action.payload.response.data)));
    case removePrinterRoutine.SUCCESS:
      return state.updateIn(['printers','data'], remove(fromJS(action.payload.request)));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/printers.js